import { v4 as uuid } from 'uuid';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import EditIcon from '@material-ui/icons/Edit';

const LatestProducts = (props) => {
        
    
    
    return (
  <Card {...props}>
    <CardHeader
      title={<Typography variant="h5" color="primary">Requirements</Typography>}
      subheader={<Typography variant="caption" color="secondary">Please provide all requirements to continue your transactions with us.</Typography>}
    />
    <Divider />
    <List>
      {props.requirements.map((product, i) => (
        <ListItem
          divider={i < props.requirements.length - 1}
          key={i}
        >
        
          <ListItemText
            primary={product.name}
                />
          <IconButton
           component={RouterLink}
            edge="end"
            size="small"
            to={product.href}
          >
         <EditIcon fontSize="small" color="primary"/>
          </IconButton>
        </ListItem>
      ))}
    </List>
    <Divider />
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        p: 2
      }}
    >
      <Button
         component={RouterLink}
       to={'/app/account'}
        color="primary"
        endIcon={<ArrowRightIcon />}
        size="small"
        variant="text"
      >
        View all
      </Button>
    </Box>
  </Card>
);

    }

export default LatestProducts;
